import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { generateSimpleID } from 'app/shared/utils/generate-simple-id';

@Component({
    selector: 'itpx-toggle-checkbox',
    templateUrl: './toggle-checkbox.component.html',
    styleUrls: ['./toggle-checkbox.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleCheckBoxComponent),
            multi: true
        }
    ],
})
export class ToggleCheckBoxComponent implements ControlValueAccessor {

    @Input() disabled: boolean = false;
    @Input() value: boolean = false;

    readonly checkboxId: string = generateSimpleID();

    onTouched: () => void;
    onChange: (value: boolean) => void;

    constructor() { }

    writeValue(value: boolean) {
        this.value = value;
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/toggle-checbox/toggle-checkbox.component.ts